/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService';
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue'),
                meta: {
                  authRequired: true
                }
              },
              {
                path: '/subscription',
                name: 'subscription',
                component: () => import('./views/Subscription.vue'),
                meta: {
                  authRequired: true
                }
              },
              {
                path: '/invoices',
                name: 'invoices',
                component: () => import('./views/Invoices.vue'),
                meta: {
                  authRequired: true
                }
              },
              {
                path: '/profile',
                name: 'profile',
                component: () => import('@/views/Profile.vue'),
                meta: {
                  authRequired: true
                }
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/login/Login.vue')
              },
              {
                path: '/pages/register',
                name: 'page-register',
                component: () => import('@/views/pages/register/Register.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})


router.beforeEach((to, from, next) => {

  firebase.auth().onAuthStateChanged(() => {

      // get firebase current user
      const firebaseCurrentUser = firebase.auth().currentUser;

      // -- Redirect to dashboard if trying access login page & already logged in
      if( firebaseCurrentUser && to.name == "page-login" ) router.push({ path: '/'});

      // if (
      //     to.path === "/pages/login" ||
      //     to.path === "/pages/forgot-password" ||
      //     to.path === "/pages/error-404" ||
      //     to.path === "/pages/error-500" ||
      //     to.path === "/pages/register" ||
      //     to.path === "/callback" ||
      //     to.path === "/pages/comingsoon" ||
      //     (auth.isAuthenticated() || firebaseCurrentUser)
      // ) {
      //     return next();
      // }

      // If auth required, check login. If login fails redirect to login page

      if(to.meta.authRequired) {
        if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
          router.push({ path: '/pages/login', query: { to: to.path } })
        }
      }


      // Specify the current path as the customState parameter, meaning it
      // will be returned to the application after auth
      // auth.login({ target: to.path });
      return next()
    });

});

export default router
